import { useEffect, useState, Key } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../components/Header";
import { useQuery } from "@tanstack/react-query";
import {getEvents, getEventsByCategories} from "../api/events.ts";
import { MoveLeft } from "lucide-react";
import EventsSkeleton from "../components/skeletons/EventsSkeleton.tsx";
import EventCard from "../components/EventCard.tsx";
import useDataStore from "../store/dataStore.ts";
import NoEvents from "../components/NoEvents.tsx";

export default function Event() {
  const { categoryReference, categoryLabel } = useParams();
  const [filteredEvents, setFilteredEvents] = useState<any[]>([]);

  //const currentEvents = useDataStore.getState().currentEvents;

  // Utilisation de useQuery
  const { data, isLoading, isError } = useQuery({
    queryKey: ["eventsByCategory", categoryReference],
    queryFn: () => getEventsByCategories(categoryReference || ""),
    enabled: !!categoryReference, // N'exécute la requête que si une catégorie est sélectionnée
  });

  const { data: events } = useQuery({
    queryKey: ["events"],
    queryFn: () => getEvents(),
    staleTime: 0,
  });

  useEffect(() => {
    if (events) {
      useDataStore.getState().setCurrentEvents(events);
    }
  }, [events]);

  useEffect(() => {
    if (data && categoryReference) {
      setFilteredEvents(data);
    } else {
      if (events) {
        setFilteredEvents(events || []);
      }
    }
  }, [data, categoryReference,events]);

  const renderEventsList = (events: any[]) => (
    <div className="flex flex-col gap-4">
      {events.map((item: { event: any }, index: Key) => {
        const event = item?.event;
        return (
            <EventCard link={`/Event/${event?.reference}`} key={index} event={event}  />
        );
      })}
    </div>
  );

  const renderContent = () => {
    if (filteredEvents.length < 0 && isLoading) {
      return <EventsSkeleton />;
    }

    if (isError) {
      return (
        <div className="text-center mt-8">
          <p className="text-red-500">
            Une erreur s'est produite lors du chargement des événements.
          </p>
        </div>
      );
    }

    if (filteredEvents.length === 0 && !isLoading) {
      return (
          <NoEvents/>
      );
    }

    return renderEventsList(filteredEvents);
  };

  return (
      <div style={{
        backgroundImage: `url('/pattern-14.png')`,
        backgroundSize: 'inherit',
        backgroundPosition: 'center',
        fontFamily: "Exo",
        backgroundRepeat: 'no-repeat'
      }} className="min-h-screen flex flex-col">
        {/* Image de fond */}
        <div className="absolute inset-0 overflow-y-auto z-10 px-4 py-4">
          <Header/>
          <div className="flex items-center">
            <div className="rounded-full w-10 h-10 bg-primary flex items-center justify-center">
              <Link to="/" className="my-2">
                <MoveLeft color="#fff" className="w-6 h-6"/>
              </Link>
            </div>
            <div className="text-xl text-black my-2 mx-2">
              {categoryLabel
                  ? `Les événements de ${categoryLabel}`
                  : "Tous les événements"}
            </div>
          </div>

          <div className="mt-4">{renderContent()}</div>
        </div>
      </div>
  );
}
